
<template>
  <div>
    <el-form class="user-search">
      <el-form-item>
        <el-button size="small" type="primary" icon="el-icon-plus" @click="handleEdit()">添加</el-button>
      </el-form-item>
    </el-form>

    <!--列表-->
    <el-table size="small" :data="listData" v-loading="loading" border element-loading-text="拼命加载中" style="width: 100%;">
      <el-table-column align="center" prop="address" label="地址" >
      </el-table-column>
      <!-- <el-table-column align="center" sortable prop="id" label="角色id" width="100">
      </el-table-column> -->
      <el-table-column align="center" prop="active" label="当前有效" >
        <template slot-scope="scope">
          <el-button v-if="!scope.row.active" size="mini" type="danger" @click="onSet(scope.row)">可设置</el-button>
          <div v-else>有效</div>
        </template>
      </el-table-column>
      <el-table-column align="center" label="链上余额" width="110">
          <template slot-scope="scope">
            <el-popover
              trigger="click">
              <div class="lines">
                <p>ETH : {{ gridData.eth }}</p>
                <p>USDT : {{ gridData.usdt }}</p>
              </div>
              <el-button slot="reference" size="mini" @click="onBalances(scope.row)">查看余额</el-button>
            </el-popover>
              
          </template>
        </el-table-column>
      <el-table-column align="center" prop="setupTime" label="加入时间" >
      </el-table-column>
      
    </el-table>
    <!-- 编辑界面 -->
    <el-dialog :title="title" :visible.sync="editFormVisible" width="30%" @click='closeDialog'>
      <el-form label-width="120px" :model="editForm" ref="editForm" :rules="rules">
        <el-form-item label="地址" prop="address">
          <el-input size="small" v-model="editForm.address" auto-complete="off" placeholder="请输入地址"></el-input>
        </el-form-item>
        <el-form-item label="私钥" prop="privateKey">
          <el-input size="small" v-model="editForm.privateKey" auto-complete="off" placeholder="请输入私钥"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button size="small" @click='closeDialog'>取消</el-button>
        <el-button size="small" type="primary" :loading="loading" class="title" @click="submitForm('editForm')">保存</el-button>
      </div>
    </el-dialog>

  </div>
</template>

<script>
import {
  withdrawUsers,
  setWithdrawUserActive,
  addWithdrawUser,
  blockBalance
} from '../../api/userMG'
import Pagination from '../../components/Pagination'
export default {
  data() {
    return {
      nshow: true, //switch开启
      fshow: false, //switch关闭
      loading: false, //是显示加载
      editFormVisible: false, //控制编辑页面显示与隐藏
      title: '添加',
      editForm: {
        address: '',
        privateKey: '',
      },
      // rules 表单验证
      rules: {
        // systemNo: [
        //   { required: true, message: '请输入系统编码', trigger: 'blur' }
        // ],
        address: [
          { required: true, message: '请输入真确地址', trigger: 'blur' }
        ],
        privateKey: [
          { required: true, message: '请输入真确私钥', trigger: 'blur' }
        ]
      },
      listData: [], //用户数据
      gridData:{
        trx:'',
        usdt:''
      }
    }
  },
  // 注册组件
  components: {
    Pagination
  },
  /**
   * 数据发生改变
   */

  watch: {},

  /**
   * 创建完毕
   */

  created() {
    this.getdata()
  },

  /**
   * 里面的方法只有被调用才会执行
   */

  methods: {
    getdata() {
      /***
       * 调用接口，注释上面模拟数据 取消下面注释
       */
       withdrawUsers()
        .then(res => {
          this.loading = false
          if (res.code != 0) {
            this.$message({
              type: 'info',
              message: res.message
            })
          } else {
            this.listData = res.data
          }
        })
        .catch(err => {
          this.loading = false
          this.$message.error('获取失败，请稍后再试！')
        })
    },
    onBalances(row){
      this.gridData = {
        trx:'',
        usdt:''
      }
      blockBalance({address:row.address}).then(res => {
        this.loading = false
        if (res.code != 0) {
          this.$message({
            type: 'info',
            message: res.message
          })
        } else {
          this.gridData = res.data
        }
      })
    },

    //显示编辑界面
    handleEdit: function() {
      this.editFormVisible = true
      this.editForm.address = ''
      this.editForm.privateKey = ''
    },
    // 编辑、增加页面保存方法
    submitForm(editData) {
      this.$refs[editData].validate(valid => {
        if (valid) {
          addWithdrawUser(this.editForm)
            .then(res => {
              this.editFormVisible = false
              this.loading = false
              if (res.code == 0) {
                this.getdata()
                this.$message({
                  type: 'success',
                  message: '添加成功！'
                })
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              this.editFormVisible = false
              this.loading = false
              this.$message.error('添加失败，请稍后再试！')
            })
        } else {
          return false
        }
      })
    },
    // 设置有效地址
    onSet(row) {
      console.log(row)
      this.$confirm('当前地址设置为有效?', '信息', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          setWithdrawUserActive({address:row.address})
            .then(res => {
              if (res.code == 0) {
                this.$message({
                  type: 'success',
                  message: '当前地址已生效!'
                })
                this.getdata()
              } else {
                this.$message({
                  type: 'info',
                  message: res.message
                })
              }
            })
            .catch(err => {
              console.log(err)
              this.loading = false
              this.$message.error('操作失败，请稍后再试！')
            })
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作'
          })
        })
    },
  
    // 关闭编辑、增加弹出框
    closeDialog() {
        this.editFormVisible = false
    }
  }
}
</script>

<style scoped>
.user-search {
  margin-top: 20px;
}
.userRole {
  width: 100%;
}
.lines p{border-bottom: 1px solid #eee;padding: 5px 0;}
</style>

 


// WEBPACK FOOTER //
// src/views/wallet/Withdrawusers.vue